import React from "react";
import styles from "../styles.module.css"

export function SelectablePlayer(props: {name: string, isSelected: boolean, onClick: () => void}) {
    return (
        <button onClick={props.onClick} className={
            styles.SpelerNaam + " " + (props.isSelected ? styles.Selected : "")
        }>{props.name}</button>
    )
}